<app-tab [items]="items" [selectedIndex]="selectedItemIndex" (onTabChange)="tabChange($event)"></app-tab>

<ng-template #usersTemplate>
  <app-dummy-data-users *ngIf="tabLoaded[0] || selectedItemIndex === 0"></app-dummy-data-users>
</ng-template>

<ng-template #doctorsTemplate>
  <app-dummy-data-doctors *ngIf="tabLoaded[1] || selectedItemIndex === 1"></app-dummy-data-doctors>
</ng-template>

<ng-template #appointmentsTemplate>
  <app-dummy-data-appointments *ngIf="tabLoaded[2] || selectedItemIndex === 2"></app-dummy-data-appointments>
</ng-template>

<ng-template #couponsTemplate>
  <app-dummy-data-coupons *ngIf="tabLoaded[3] || selectedItemIndex === 3"></app-dummy-data-coupons>
</ng-template>

<ng-template #medicinesTemplate>
  <app-dummy-data-medicines *ngIf="tabLoaded[4] || selectedItemIndex === 4"></app-dummy-data-medicines>
</ng-template>